import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import { interval, tap } from 'rxjs';

import { InactivityCheckDialogResult } from '~console/app/~shared/models/inactivity-check.models';
import { SharedModule } from '~console/app/~shared/modules/shared.module';

type InactivityCheckDialogData = {
  warningDurationSeconds: number;
};

@Component({
  selector: 'inactivity-check-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './inactivity-check-dialog.component.html',
  styleUrls: ['./inactivity-check-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InactivityCheckDialogComponent {
  private readonly _dialogRef = inject(
    MatDialogRef<InactivityCheckDialogComponent, InactivityCheckDialogResult>
  );

  private readonly _data = inject<InactivityCheckDialogData>(MAT_DIALOG_DATA);

  readonly remainingSeconds = signal(
    Math.max(1, this._data.warningDurationSeconds)
  );

  readonly countdownLabel = computed(() => {
    const remaining = this.remainingSeconds();
    return `${remaining}s`;
  });

  constructor() {
    interval(1000)
      .pipe(
        takeUntilDestroyed(),
        tap(() => {
          this.remainingSeconds.update(value => {
            const nextValue = value - 1;
            if (nextValue <= 0) {
              this._dialogRef.close('timeout');
              return 0;
            }
            return nextValue;
          });
        })
      )
      .subscribe();
  }

  stayConnected(): void {
    this._dialogRef.close('stay');
  }
}
